import StatusChip from 'components/@extended/StatusChip';
import { PencilLineIcon } from 'components/icons';
import { differenceInCalendarDays, parseISO } from 'date-fns';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

/** A draft's people are told this many days before it is deleted, and from then on its chip says so. */
export const DELETION_NOTICE_DAYS = 7;

/** Marks a record that is a draft. It goes first, before the record's status chip. */
export function DraftChip({ className }: { className?: string }) {
    return (
        <StatusChip
            type="draft"
            icon={<PencilLineIcon className="size-3" />}
            label={t('draft.chip')}
            className={cn('px-1.5', className)}
        />
    );
}

/**
 * How soon a draft nobody saves is deleted, once its people have been told: nothing before then, where a surface
 * shows the date as plain meta text. `deletesOn` is the `yyyy-MM-dd` date the server gives.
 */
export function DraftDeletionChip({ deletesOn }: { deletesOn: string }) {
    const days = Math.max(0, differenceInCalendarDays(parseISO(deletesOn), new Date()));
    return days > DELETION_NOTICE_DAYS ? null : (
        <StatusChip type="warning" label={t('draft.expires-in', { days: String(days) })} />
    );
}
